import { TFunction } from 'i18next'

import { OldIconName } from '@/components/atomic/organisms/GlobalFooter'

type Footer = {
  description: string
  iconLink: {
    name: OldIconName
    url: string
    'aria-label'?: string
  }[]
  address: string
  aboutTransaction: string
  copyright: string
}

export const getFooterData = (language: string, t: TFunction<'translation', undefined>): Footer => {
  return {
    description: `${t('common.footer.company.name')}${
      language === 'ko-KR'
        ? `
        ${t('common.footer.company.companyCode')}
              ${t('common.footer.company.saleCode')}`
        : ''
    }
    ${language === 'ja-JP' ? `${t('common.footer.company.create')}` : ''}`,
    iconLink: [
      {
        name: 'youtube',
        url: t('common.footer.sns.youtube_gutv.link'),
        'aria-label': t('common.footer.sns.youtube_gutv.imgImgAlt'),
      },
      {
        name: 'instagram',
        url: t('common.footer.sns.instagram.link'),
        'aria-label': t('common.footer.sns.instagram.imgImgAlt'),
      },
      {
        name: 'twitter',
        url: t('common.footer.sns.twitter.link'),
        'aria-label': t('common.footer.sns.twitter.imgImgAlt'),
      },
      {
        name: 'line',
        url: t('common.footer.sns.line.link'),
        'aria-label': t('common.footer.sns.line.imgImgAlt'),
      },
    ],
    address: t('common.footer.company.address'),
    aboutTransaction: t('webFooterNoLiabilityTransactions'),
    copyright: t('common.footer.company.copyright'),
  }
}
